import React from "react";
import {
  SELECTED_ELEMENT_COLOR,
  defaultObjectSizes,
  OBJECT_TYPES,
} from "../configuratorConstants";
// Убедитесь, что путь к иконке правильный (в списке файлов он был в Assets/Ворота.svg)
import { ReactComponent as GateIcon } from "../../Assets/Ворота.svg";

const GateRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
}) => {
  const defaults = defaultObjectSizes[OBJECT_TYPES.GATE];
  
  // Ширина проема (влево-вправо)
  const elementVisualWidthM = element.width || defaults.width;
  
  // Глубина/Толщина (вверх-вниз) - то, что вы хотите увеличить
  const elementPlanDepthM = element.depth || defaults.depth;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementPlanDepthPx = elementPlanDepthM * scale;
  const wallThicknessPx = wallThickness * scale;

  // Центрируем ворота относительно толщины стены
  // Если нужно, чтобы они торчали наружу или внутрь, можно изменить yOffset
  const yOffset = placementSideFactor * (wallThicknessPx / 2 - elementPlanDepthPx / 2); 
  
  // Если ворота должны быть строго по центру стены:
  // const yOffset = 0; 

  const iconStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "#fff", // Цвет фона
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563", // Цвет линий
    strokeWidth: isSelected ? 1.5 : 1,
    pointerEvents: "none",
  };

  // Если нужно отразить ворота в зависимости от стороны стены
  const groupTransform = `translate(0, 0) ${
    placementSideFactor === 1 ? "scale(1, -1)" : ""
  }`;

  return (
    <g transform={groupTransform}>
      {/* Невидимая область для клика, чтобы легче было выделять */}
      <rect
        x={-elementVisualWidthPx / 2}
        y={-wallThicknessPx / 2} // Кликабельная зона по толщине стены
        width={elementVisualWidthPx}
        height={wallThicknessPx}
        fill="transparent"
      />

      {/* Сами ворота */}
      <GateIcon
        x={-elementVisualWidthPx * 0.14}
        y={-elementPlanDepthPx * 0.078} // Центрируем по вертикали
        width={elementVisualWidthPx * 0.83}
        height={elementPlanDepthPx / 4.5}
        style={iconStyle}
        // ВАЖНО: "none" позволяет растягивать высоту (толщину) независимо от ширины
        preserveAspectRatio="none" 
      />
    </g>
  );
};

export default React.memo(GateRenderer);